import { Box, CircularProgress } from '@mui/material';

export const Loader = ({ ...props }) =>
  <Box display="flex" justifyContent="center" {...props}>
    <CircularProgress />
  </Box>;
